var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCriticalPaths(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9069 0H1.50435V1.2H12.3303L14.4074 3.79553L12.9593 6.28364H2.70663L0 10.1418L2.70663 14H10.7829C11.0146 15.1411 12.0234 16 13.2329 16C14.6136 16 15.7329 14.8807 15.7329 13.5C15.7329 12.1193 14.6136 11 13.2329 11C12.0952 11 11.135 11.76 10.8322 12.8H3.33064L1.46584 10.1418L3.33064 7.48364H13.6494L15.8584 3.6881L12.9069 0ZM14.5329 13.5C14.5329 14.218 13.9509 14.8 13.2329 14.8C12.5149 14.8 11.9329 14.218 11.9329 13.5C11.9329 12.782 12.5149 12.2 13.2329 12.2C13.9509 12.2 14.5329 12.782 14.5329 13.5Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCriticalPaths);
export default __webpack_public_path__ + "static/media/icon--critical-paths.2076b6c53524ad044c3a24d5e4f5aaf7.svg";
export { ForwardRef as ReactComponent };